class GlobalInfo extends Map {
  urlQuery = {};
  get scrollTop() {
    return Math.max(
      window.pageYOffset || 0,
      window.scrollY || 0,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
  }
  get scrollHeight() {
    return Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
  }
  init() {
    this.initUrlQuery();
    return this;
  }
  initUrlQuery() {
    this.urlQuery = {};
    let queryString = location.search.replace("?", "");
    queryString.split("&").forEach(str => {
      let [key, value] = str.split("=");
      if (!key || !value) {
        return;
      }
      this.urlQuery[key] = value;
    });
    return this;
  }
}

export default new GlobalInfo();
